import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { usePinnedCycleStore } from '../../stores/prioritization/pinnedCycleStore';
import { useTrackStore } from '../../stores/prioritization/trackStore';
import { useAllSessions } from '../../stores/prioritization/sessionStore';
import { shouldShowFocusModeBarForRoute } from '../../lib/focusModeBarContext';

/**
 * True when focus mode is active and the current route is scoped to the pinned cycle
 * (so the CycleContextBar should render).
 */
export function useFocusModeBarAligned(): boolean {
  const location = useLocation();
  const pinnedCycleId = usePinnedCycleStore((s) => s.pinnedCycleId);
  const tracks = useTrackStore((s) => s.tracks);
  const sessions = useAllSessions() ?? [];

  const tracksById = useMemo(
    () => new Map(tracks.map((t) => [t.id, { id: t.id, cycleId: t.cycleId }])),
    [tracks]
  );
  const sessionsById = useMemo(
    () => new Map(sessions.map((s) => [s.id, { id: s.id, cycleId: s.cycleId ?? undefined }])),
    [sessions]
  );

  return useMemo(() => {
    if (!pinnedCycleId) return false;
    const sp = new URLSearchParams(location.search);
    return shouldShowFocusModeBarForRoute(
      location.pathname,
      sp,
      pinnedCycleId,
      tracksById,
      sessionsById
    );
  }, [location.pathname, location.search, pinnedCycleId, tracksById, sessionsById]);
}
